// extracted by mini-css-extract-plugin
export var actions = "bH_fp";
export var content = "bH_F";
export var headline = "bH_fn";
export var imageContainer = "bH_bH";
export var singleCtaContainer = "bH_fl";
export var variant = "bH_fm";
export var wrapper = "bH_bR";